module.exports = __webpack_public_path__ + "static/media/Minerva_LogoColor.11ad8cda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Minerva_LogoColor.svg
// module id = 1259
// module chunks = 0